import { buildLink } from '../components/common/contextLink';
import { availableLanguages } from '../components/common/webSiteLanguages';
import { useGlobalData } from '../providers/globalDataProvider/globalDataProvider.useGlobalData';

export const LINKS_TO_USE_IN = {
  FOOTER: 'footer',
  MAIN: 'main',
};

const getFooterOnlyLinks = ({ country }) => (
  availableLanguages.find((c) => c.country === country) || { links: [] }
).links.filter((l) => l[LINKS_TO_USE_IN.FOOTER] && !l[LINKS_TO_USE_IN.MAIN]);

const getMainLinks = ({ country }) => (
  availableLanguages.find((c) => c.country === country) || { links: [] }
).links.filter((l) => l[LINKS_TO_USE_IN.MAIN]);

export const getLinkByComponentName = ({ componentName, country }) => (
  availableLanguages.find((c) => c.country === country) || { links: [] }
).links.find((l) => l.component === componentName);

export const useNavigationLinks = ({ toUseIn }) => {
  const { country, language } = useGlobalData();
  let links = [];
  switch (toUseIn) {
    case LINKS_TO_USE_IN.MAIN:
      links = getMainLinks({ country });
      break;
    case LINKS_TO_USE_IN.FOOTER:
      links = getFooterOnlyLinks({ country });
      break;
    default:
      links = getMainLinks({ country });
      break;
  }

  return links.map((link) => ({
    to: buildLink({ pathname: link[`slug_${language}`], country, language }),
    label: link.label,
    slug: link[`slug_${language}`],
    component: link.component,
    new_tab: link.new_tab,
  }));
};

export default useNavigationLinks;
